
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
          <h1 class="descContent"> {{info}}</h1>
      </mat-dialog-content>
      <mat-dialog-actions align="center">
        <button mat-raised-button  (click)="close()">OK</button>
      </mat-dialog-actions>
    </form>
  